"use client";

import { useState } from "react";

// Pole hasła z przyciskiem „pokaż/ukryj". Zamiennik <input type="password">.
// Działa i dla pól kontrolowanych (value/onChange), i z server-action (name/defaultValue) —
// wszystkie propsy idą do <input>, a `type` zawsze nadpisujemy wg stanu pokazywania.
export default function PasswordInput({
  className = "",
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={show ? "text" : "password"}
        className={`${className} pr-10`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? "Ukryj hasło" : "Pokaż hasło"}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-[var(--p-muted)] transition hover:text-[var(--p-heading)]"
      >
        {show ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m2 2 20 20" />
            <path d="M6.71 6.7C3.96 8.36 2 12 2 12s3 7 10 7c1.59 0 3.02-.36 4.29-.94M9.88 5.09A9.7 9.7 0 0 1 12 5c7 0 10 7 10 7a13 13 0 0 1-1.67 2.68" />
            <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}
